<template>
  <b-container fluid class="p-0">
    <!-- STEP -1 -->
    <template v-if="step == -1">
      <div class="vh-100">
        <div class="h-100 d-flex flex-column justify-content-center">
          <h4 class="text-center mb-3 ls-08">{{ loading.message }}</h4>
          <b-spinner class="mt-2 mx-auto" variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </template>
    <!-- STEP 0 -->
    <template v-else-if="step == 0">
      <div style="background: #f9f9f9">
        <div
          class="position-fixed"
          v-bind:style="{
            top: innerWidth > BREAKPOINTS.LG ? '50px' : '10px',
            left: innerWidth > BREAKPOINTS.LG ? '50px' : '15px',
          }"
        >
          <Logo :image="cache.settings[0].logo" :url="cache.settings[0].url" />
        </div>
        <b-container
          fluid
          v-bind:class="{
            'vh-100': innerWidth > BREAKPOINTS.XXL,
            'py-5': innerWidth <= BREAKPOINTS.XXL,
          }"
        >
          <div class="h-100 d-flex flex-column justify-content-center">
            <div class="d-flex flex-column align-items-center justify-content-center">
              <transition appear name="fade">
                <h4 class="text-center mb-3 ls-08">Build your RAND boat</h4>
              </transition>
              <p class="text-center mb-5 px-4 ls-08 fs-14" style="max-width: 500px; font-weight: 300">Configure and calculate the price of your favorite RAND Boat</p>
            </div>
            <div class="d-flex justify-content-center" v-bind:class="{ 'flex-column': innerWidth <= BREAKPOINTS.XXL }">
              <div
                class="d-flex flex-column align-items-center justify-content-end h-100"
                v-for="(product, index) in cache.products"
                :key="index"
                v-bind:class="{
                  'mr-5': innerWidth > BREAKPOINTS.XXL,
                  'mt-5': innerWidth <= BREAKPOINTS.XXL,
                }"
              >
                <transition appear name="fade">
                  <img :src="product.image" :alt="product.name" :width="product.image_width" />
                </transition>
                <h5 class="text-uppercase mb-0 mt-5 ls-08 no-weglot">
                  {{ product.name }}
                </h5>
                <b-button variant="primary" class="mt-3 text-uppercase ls-08 fs-14" :to="'./' + product.url">SELECT</b-button>
              </div>
              <div v-if="innerWidth > BREAKPOINTS.XXL" class="position-fixed" style="bottom: 25px; right: 25px">
                <p class="m-0 ls-08 fs-10 no-weglot">
                  Powered by &copy;
                  <a class="m-0 ls-08 fs-10" href="https://www.reepco.dk" target="_blank">REEPCO STUDIO</a>
                </p>
              </div>
              <div v-else>
                <p class="text-center mt-5 ls-08 fs-10 no-weglot">
                  Powered by &copy;
                  <a class="ls-08 fs-10" href="https://www.reepco.dk" target="_blank">REEPCO STUDIO</a>
                </p>
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </template>
    <!-- STEP 1 -->
    <template v-else-if="step == 1">
      <!-- <cWeglot /> -->
      <b-container fluid class="p-0">
        <template v-if="innerWidth > BREAKPOINTS.LG">
          <div
            class="position-fixed"
            style="z-index: 1"
            v-bind:style="{
              top: innerWidth > BREAKPOINTS.LG ? '50px' : '10px',
              left: innerWidth > BREAKPOINTS.LG ? '50px' : '15px',
            }"
          >
            <Logo :image="cache.settings[0].logo" :url="cache.settings[0].url" />
          </div>
        </template>
        <template v-else>
          <div
            class="position-fixed"
            style="z-index: 1"
            v-bind:style="{
              top: innerWidth > BREAKPOINTS.LG ? '50px' : '10px',
              left: innerWidth > BREAKPOINTS.LG ? '50px' : '15px',
            }"
          >
            <Logo :image="cache.settings[0].logo" :url="cache.settings[0].url" />
          </div>
          <div class="position-fixed" style="z-index: 1; top: 10px; right: 15px">
            <h4 class="text-uppercase ls-08 m-0 no-weglot" style="color: #a7acb4; font-size: 15px; letter-spacing: 0.1em; font-weight: 400">
              {{ product.name }}
            </h4>
          </div>
        </template>
        <b-row ref="innerHeightFix" class="m-0" style="overflow: hidden" v-bind:style="{ height: innerHeight }">
          <b-col
            class="p-0"
            cols="12"
            lg="8"
            v-bind:style="{
              height: innerWidth > BREAKPOINTS.LG ? '100%' : '40%',
            }"
            v-bind:class="{
              'pb-2': innerWidth <= BREAKPOINTS.LG,
              'px-2': innerWidth <= BREAKPOINTS.LG,
            }"
          >
            <template v-if="innerWidth > BREAKPOINTS.LG">
              <div
                class="position-absolute"
                style="z-index: 1340; color: #a7acb4"
                v-bind:style="{
                  top: innerWidth > BREAKPOINTS.LG ? '50px' : '10px',
                  right: innerWidth > BREAKPOINTS.LG ? '50px' : '15px',
                }"
              >
                <h4 class="text-uppercase ls-08 m-0 no-weglot" style="font-size: 15px; letter-spacing: 0.1em; font-weight: 400">
                  {{ product.name }}
                </h4>
              </div>
            </template>
            <b-card class="mb-2 d-flex flex-column justify-content-between border-0 h-100" no-body>
              <div
                style="position: relative; flex: 1; width: 100%; max-width: 1440px; margin: auto"
                class=""
                v-bind:class="{
                  'overflow-hidden': innerWidth <= BREAKPOINTS.LG,
                }"
              >
                <div class="position-relative h-100 d-flex align-items-center justify-content-center">
                  <template v-for="(option, index) in configuration.options">
                    <transition appear name="fade" :key="index">
                      <img class="position-absolute w-100" v-if="option[view]" :src="option[view]" :alt="option.name" :key="index" />
                    </transition>
                  </template>
                </div>
                <div
                  v-if="false == true"
                  class="d-flex justify-content-center position-absolute w-100 text-align-center"
                  style="gap: 50px"
                  v-bind:style="{
                    bottom: innerWidth > BREAKPOINTS.LG ? '40px' : '5px',
                  }"
                >
                  <!-- <template v-if="cache.settings[0].range"> -->
                  <template v-if="configuration.range">
                    <div>
                      <AnimatedNumber :value="configuration.range" :formatValue="formatRange" :duration="500" />
                      <p class="preview2d__description">range</p>
                    </div>
                  </template>
                  <!-- <template v-if="cache.settings[0].top_speed"> -->
                  <template>
                    <div>
                      <AnimatedNumber :value="configuration.top_speed" :formatValue="formatTopSpeed" :duration="500" />
                      <p class="preview2d__description">top speed</p>
                    </div>
                  </template>
                  <template v-if="cache.settings[0].acceleration">
                    <div>
                      <AnimatedNumber :value="configuration.acceleration" :formatValue="formatAcceleration" :duration="500" />
                      <p class="preview2d__description">0-100 KM/T</p>
                    </div>
                  </template>
                </div>
                <!-- <Preview2D /> -->
              </div>
            </b-card>
          </b-col>
          <b-col
            class="p-0 bg-secondary border-left"
            cols="12"
            style="border-top: 1px solid #dee2e6 !important"
            lg="4"
            v-bind:style="{
              height: innerWidth > BREAKPOINTS.LG ? '100%' : '60%',
            }"
          >
            <div
              class="main-body overflow-auto custom-scrollbar"
              style="position: relative"
              v-bind:style="{
                padding: innerWidth > BREAKPOINTS.LG ? '2rem' : '1.5rem',
                height: innerWidth > BREAKPOINTS.LG ? '91%' : '85%',
              }"
            >
              <cWeglot />
              <div class="notification">
                <div class="notification-title">
                  <p>PRE-CONFIGURED BOATS</p>
                  <br />
                </div>
                <p>Can't wait to get on the water? View <a href="https://www.randboats.com/pages/inventory-list">our boats</a> that are ready for delivery.</p>
              </div>
              <div class="switchers d-flex justify-content-between align-items-center">
                <b-form-checkbox class="mb-2" autocomplete="off" v-model="showStandard" switch>Show standard options</b-form-checkbox>
              </div>
              <div class="mb-2" v-for="(category, index) in product.categories" :key="index">
                <template v-if="getObjectByReferenceEquals(cache.categories, '_reference', category).view == 'list'">
                  <h5 class="my-4 title-font">
                    {{ getObjectByReferenceEquals(cache.categories, '_reference', category).name }}
                  </h5>
                  <template v-for="(option, index) in getOptions(category)">
                    <b-card class="mt-2 cursor-pointer hover-zoom2" no-body v-bind:class="{ selected: selectedClass(option) }" v-on:click="toggleOption(category, option)" v-if="(option.standard && showStandard) || !option.standard" :key="index">
                      <b-row class="m-0 p-2">
                        <template v-if="cache.settings[0].thumbnails">
                          <b-col cols="3" class="p-0">
                            <div class="h-100 d-flex justify-content-center align-items-center">
                              <transition appear name="fade2">
                                <img class="w-100" style="max-width: 90px" :src="option.thumbnail" alt="" />
                              </transition>
                            </div>
                          </b-col>
                        </template>
                        <b-col :cols="cache.settings[0].thumbnails ? 9 : 12" class="p-3" v-b-tooltip.hover.bottom="option.description">
                          {{ option.name }} <br />
                          <b> €{{ numberToEuro(option.price) }} </b>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </template>
                <!-- TAB VIEW -->
                <template v-if="getObjectByReferenceEquals(cache.categories, '_reference', category).view == 'tab'">
                  <h5 class="my-4 title-font">
                    {{ getObjectByReferenceEquals(cache.categories, '_reference', category).name }}
                  </h5>
                  <b-container fluid class="pb-2">
                    <b-row>
                      <b-col cols="6" class="p-0">
                        <b-button :variant="tabs.engine == 'electric' ? 'primary' : 'secondary'" class="w-100" v-on:click="tabs.engine = 'electric'">Electric</b-button>
                      </b-col>
                      <b-col cols="6" class="p-0">
                        <b-button :variant="tabs.engine == 'petrol' ? 'primary' : 'secondary'" class="w-100" v-on:click="tabs.engine = 'petrol'">Petrol</b-button>
                      </b-col>
                    </b-row>
                  </b-container>
                  <template v-for="(option, index) in getOptions(category)">
                    <template v-if="option.engine_type == tabs.engine">
                      <b-card class="mt-2 cursor-pointer hover-zoom2" no-body v-bind:class="{ selected: selectedClass(option) }" v-on:click="toggleOption(category, option)" v-if="option.standard || !option.standard" :key="index">
                        <div class="option-body p-4 d-flex justify-content-between align-items-center">
                          <div>
                            <p class="m-0">{{ option.name }}</p>
                            <p class="text-muted m-0">
                              {{ option.description }}
                            </p>
                          </div>
                          <div>
                            <b> €{{ numberToEuro(option.price) }} </b>
                          </div>
                        </div>
                      </b-card>
                    </template>
                  </template>
                </template>
                <template v-if="getObjectByReferenceEquals(cache.categories, '_reference', category).view == 'grid'">
                  <div class="option-header d-flex justify-content-between align-items-center">
                    <h5 class="my-4 title-font">
                      {{ getObjectByReferenceEquals(cache.categories, '_reference', category).name }}
                    </h5>
                    <p v-if="lastSelected[category]" class="m-0 title-font no-weglot">
                      {{ lastSelected[category].name }}
                      <b>€ {{ numberToEuro(lastSelected[category].price) }}</b>
                    </p>
                    <p v-else class="m-0">Standard <b>€ 0</b></p>
                  </div>
                  <b-row class="m-0">
                    <template v-for="(option, index) in getOptions(category)">
                      <b-col class="p-0" cols="4" sm="3" md="2" lg="3" xl="2" v-on:click="toggleOption(category, option)" v-if="option.standard || !option.standard" :key="index">
                        <div class="mr-2 mb-2">
                          <transition appear name="fade2">
                            <img
                              class="hover-zoom w-100 rounded cursor-pointer"
                              v-bind:class="{
                                selected2: selectedClass(option),
                              }"
                              :src="option.thumbnail"
                              alt=""
                            />
                          </transition>
                        </div>
                      </b-col>
                    </template>
                  </b-row>
                </template>
              </div>
            </div>
            <div
              v-bind:style="{
                height: innerWidth > BREAKPOINTS.LG ? '9%' : '15%',
              }"
              class="d-flex align-items-center border-top bg-white"
            >
              <div class="router-links d-flex justify-content-between px-5" style="flex: 1">
                <div>
                  <router-link class="d-flex flex-column align-items-center justify-content-center" :to="'./'">
                    <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
                    <p class="m-0" style="font-size: 10px; color: #666666">MODELS</p>
                  </router-link>
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center" style="cursor: pointer" v-on:click="reset()">
                  <b-icon icon="arrow-clockwise" aria-hidden="true"></b-icon>
                  <p class="m-0" style="font-size: 10px; color: #666666">RESET</p>
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center" style="cursor: pointer" v-on:click="switchSide">
                  <b-icon icon="arrow-left-right" aria-hidden="true"></b-icon>
                  <p class="m-0" style="font-size: 10px; color: #666666">TURN</p>
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center" style="cursor: pointer; position: relative" v-on:click="copyURL">
                  <div style="position: absolute; top: -65px; white-space: nowrap">
                    <b-alert style="background-color: #e5ebf5; color: black; border-color: #e5ebf5; font-size: 16px" :show="dismissCountDown" variant="warning" @dismissed="dismissCountDown = 0">URL copied to clipboard</b-alert>
                  </div>
                  <b-icon icon="share" aria-hidden="true"></b-icon>
                  <p class="m-0" style="font-size: 10px; color: #666666">SHARE</p>
                </div>
              </div>
              <div
                type="button"
                v-on:click="step = 2"
                class="router-button h-100 no-appearance bg-primary text-white d-flex justify-content-center align-items-center"
                v-bind:style="{
                  width: innerWidth > BREAKPOINTS.LG ? '250px' : 'inherit',
                  padding: innerWidth < BREAKPOINTS.LG ? '1rem' : '',
                }"
              >
                <div class="text-center w-100">
                  <p class="m-0">€{{ getPrice() }}</p>
                  <p class="m-0" style="font-size: 10px; color: #a7acb4">REQUEST QUOTE</p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <!-- STEP 2 -->
    <template v-else-if="step == 2">
      <b-container
        :fluid="innerWidth <= BREAKPOINTS.LG"
        class="d-flex flex-column vh-100 request__flex"
        v-bind:style="{
          justifyContent: innerWidth > BREAKPOINTS.LG ? 'flex-start' : 'flex-start',
          padding: innerWidth > BREAKPOINTS.LG ? '0px' : '10px',
        }"
      >
        <div
          class="position-fixed"
          v-bind:style="{
            top: innerWidth > BREAKPOINTS.LG ? '50px' : '10px',
            left: innerWidth > BREAKPOINTS.LG ? '50px' : '15px',
          }"
          style="z-index: 1"
        >
          <Logo :image="cache.settings[0].logo" :url="cache.settings[0].url" />
        </div>
        <b-row
          class="m-0"
          v-bind:style="{
            paddingTop: innerWidth <= BREAKPOINTS.LG ? '50px' : '0',
          }"
        >
          <transition appear name="fade">
            <b-col cols="12" lg="6" style="padding: 0 10px 50px 10px">
              <b-col cols="12" class="p-0">
                <!-- <h2 class="ls-08 mt-5 text-capitalize" style="font-size: 24px; font-weight: 400; letter-spacing: 1.8px">Request quote</h2> -->
                <div class="request__nav">
                  <p v-on:click="step = 1">Configure</p>
                  <p class="current">Send request</p>
                </div>
              </b-col>
              <b-col cols="12" class="p-0 mt-5">
                <div type="button" v-b-toggle.collapse-1 class="no-appearance d-flex justify-content-between align-items-center border p-3">
                  <p class="m-0 no-weglot" style="font-size: 15px; text-transform: uppercase; letter-spacing: 1.3px; font-weight: 500">
                    {{ product.name }}
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="m-0">€{{ getPrice() }}</p>
                    <div class="ml-2 border-left">
                      <b-icon class="ml-3" icon="caret-down-fill" aria-hidden="true"></b-icon>
                    </div>
                  </div>
                </div>
                <b-collapse id="collapse-1" class="mt-2 mb-3">
                  <b-card>
                    <div class="d-flex justify-content-between align-items-center" v-for="(option, index) in configuration.options" :key="index">
                      <p class="m-0 no-weglot" style="font-size: 14px">
                        {{ option.name }}
                      </p>
                      <p class="m-0" style="font-size: 14px">€{{ option.price }}</p>
                    </div>
                  </b-card>
                </b-collapse>
                <div class="mb-3">
                  <small class="text-muted">Price ex. VAT and delivery costs</small>
                </div>
                <p class="ls-08 text-capitalize">Contact</p>
              </b-col>
              <b-form @submit.prevent="onSubmit">
                <b-row>
                  <b-col cols="6">
                    <b-form-group>
                      <b-form-input id="firstname" v-model="quote.firstname" placeholder="First name" required></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <b-form-input id="lastname" v-model="quote.lastname" placeholder="Last name" required></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <b-form-input id="email" type="email" v-model="quote.email" placeholder="Email address" required></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <input v-model="quote.phone" class="form-control" required="required" aria-required="true" type="tel" id="phone" ref="intlTelInput" />
                      <!-- <b-form-input id="phone" type="tel" v-model="quote.phone" placeholder="Phone" required></b-form-input> -->
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <!-- fix font size -->
                    <!-- <b-form-checkbox id="marketing" v-model="quote.marketing" name="marketing">
                      <p class="m-0" style="font-size: 13px; padding-top: 2px">Send email to me about marketing</p>
                    </b-form-checkbox> -->
                  </b-col>
                  <b-col cols="12" class="mt-4">
                    <p class="ls-08 text-capitalize">Address</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <b-form-select id="country" v-model="quote.country" :options="countries" required></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <b-form-select id="cardinal" v-model="quote.cardinal" :options="cardinals" required></b-form-select>
                      <!-- <div class="mb-3">
                        <small class="text-muted">The region of your residence</small>
                      </div> -->
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <b-form-input id="zipcode" v-model="quote.zipCode" placeholder="Zip code" required></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <b-form-input id="city" v-model="quote.city" placeholder="City" required></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" class="mt-4">
                    <p class="ls-08 text-capitalize">Comments</p>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group>
                      <b-form-textarea id="comment" style="overflow: auto" v-model="quote.textarea" placeholder="If you have any important information or requests, please let us know" rows="5"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6" class="d-flex align-items-center mt-2">
                    <!-- <p class="no-appearance text-capitalize ls-08 fs-14 mb-0" type="button" v-on:click="setup()">Back</p> -->
                    <b-form-checkbox id="checkbox-1" v-model="quote.accept" value="accepted" unchecked-value="not_accepted" required> I accept that sales representatives from RAND Boats may store and process my contact details including contacting me directly via. my contact information. </b-form-checkbox>
                  </b-col>
                  <template v-if="innerWidth > BREAKPOINTS.LG">
                    <b-col cols="6" class="mt-2">
                      <b-button type="submit" :disabled="sending || quote.accept != 'accepted'" variant="primary" class="text-uppercase ls-08 fs-14 w-100" style="padding: 12px">{{ sending ? 'Please wait..' : 'Send request' }}</b-button>
                    </b-col>
                  </template>
                  <div class="mx-3 w-100" v-else>
                    <b-button type="submit" :disabled="sending || quote.accept != 'accepted'" variant="primary" class="w-100 text-uppercase ls-08 fs-14" style="padding: 12px; margin-top: 20px">{{ sending ? 'Please wait..' : 'Send request' }}</b-button>
                    <br />
                    <!-- <p class="no-appearance text-center text-capitalize ls-08 fs-14" type="button" style="margin-top: 1rem" v-on:click="setup()">Back</p> -->
                  </div>
                </b-row>
              </b-form>
            </b-col>
          </transition>
          <transition appear name="fade2">
            <b-col cols="6" class="d-flex flex-column justify-content-start" v-if="innerWidth >= BREAKPOINTS.LG">
              <div
                style="flex: 1"
                class=""
                v-bind:class="{
                  'overflow-hidden': innerWidth <= BREAKPOINTS.LG,
                }"
              >
                <div class="position-relative h-100 d-flex align-items-center justify-content-center">
                  <template v-for="(option, index) in configuration.options">
                    <img class="position-absolute w-100" v-if="option[view]" :src="option[view]" :alt="option.name" :key="index" />
                  </template>
                </div>
              </div>
            </b-col>
          </transition>
          <!-- <b-col cols="12" class="mt-5" v-if="innerWidth > BREAKPOINTS.LG">
            <div class="d-flex justify-content-between align-items-baseline">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="85.322" height="20.539" viewBox="0 0 85.322 20.539">
                  <g id="Group_388" data-name="Group 388" transform="translate(-68.863 -37.097)">
                    <g id="Group_142" data-name="Group 142" transform="translate(68.863 37.097)">
                      <path id="Path_42" data-name="Path 42" d="M319.711,253.346a4.91,4.91,0,0,1,.5.189.674.674,0,0,1,.405.657c-.009.841,0,1.682,0,2.524v16.119c0,.9-.721,1.307-1.575.881a1.3,1.3,0,0,1-.42-.328q-4.522-5.55-9.033-11.108-1.875-2.307-3.752-4.612c-.038-.047-.082-.091-.164-.181v.333q0,7.56,0,15.119a.8.8,0,0,1-.706.872,1.139,1.139,0,0,1-1.224-.439.992.992,0,0,1-.072-.439q-.005-5.881,0-11.762c0-2.3.007-4.6-.007-6.9a.774.774,0,0,1,.514-.764,1.2,1.2,0,0,1,1.443.273q3.07,3.835,6.137,7.67l6.73,8.409c.024.031.052.06.126.144V254.342c0-.592.193-.819.81-.954a.416.416,0,0,0,.087-.041Z" transform="translate(-258.122 -253.346)" fill="#233043" />
                      <path id="Path_43" data-name="Path 43" d="M96.061,253.346c.4.066.8.122,1.2.2a6.037,6.037,0,0,1,5.066,5.266,6.374,6.374,0,0,1-3.72,6.489c-.074.036-.147.074-.245.123.364.445.721.881,1.08,1.317q2.295,2.794,4.591,5.586a1.16,1.16,0,0,1,.289.743.749.749,0,0,1-.638.775,1.2,1.2,0,0,1-1.212-.382q-2.945-3.608-5.9-7.213a.568.568,0,0,0-.5-.236c-1.862.009-3.724.005-5.585.005h-.339v6.862a.992.992,0,0,1-1.361.951,1.107,1.107,0,0,1-.7-.532V253.87a1.021,1.021,0,0,1,.551-.524Zm-5.894,10.862h.313c1.8,0,3.591-.019,5.386.011a3.376,3.376,0,0,0,1.642-.4,4.667,4.667,0,0,0,2.715-4.95,4.1,4.1,0,0,0-1.648-2.687,4.825,4.825,0,0,0-2.845-.827c-1.819-.027-3.639-.016-5.458-.02a.546.546,0,0,0-.1.023Z" transform="translate(-88.093 -253.346)" fill="#233043" />
                      <path id="Path_44" data-name="Path 44" d="M237.1,253.346a1,1,0,0,1,.556.571q3.1,6.681,6.223,13.355,1.291,2.768,2.58,5.538a1.087,1.087,0,0,1,.1.363.614.614,0,0,1-.343.639.622.622,0,0,1-.715-.12c-.773-.654-1.552-1.3-2.305-1.974a48.611,48.611,0,0,1-4.155-4.086c-.294-.334-.559-.691-.844-1.033a4.858,4.858,0,0,1-.986-2.581c-.214-1.635-.414-3.272-.556-4.914s-.2-3.307-.308-4.96a.75.75,0,0,1,.4-.8Z" transform="translate(-205.024 -253.346)" fill="#233043" />
                      <path id="Path_45" data-name="Path 45" d="M192.073,253.346a.793.793,0,0,1,.393.827c-.124,1.9-.214,3.8-.361,5.695a32.715,32.715,0,0,1-.727,5.2,5.314,5.314,0,0,1-1.219,2.1,39.9,39.9,0,0,1-4.058,4.1c-.889.8-1.806,1.576-2.718,2.354-.331.283-.631.314-.877.135a.726.726,0,0,1-.173-.911q1.3-2.79,2.6-5.579,2.216-4.755,4.431-9.51c.593-1.274,1.191-2.546,1.777-3.823a1.157,1.157,0,0,1,.529-.594Z" transform="translate(-162.356 -253.346)" fill="#233043" />
                      <path id="Path_46" data-name="Path 46" d="M88.644,253.346a1.021,1.021,0,0,0-.551.524v-.524Z" transform="translate(-88.093 -253.346)" fill="#233043" />
                      <path id="Path_47" data-name="Path 47" d="M410.961,263.766q0-4.677,0-9.354c0-.582.289-.857.9-.857,2.029,0,4.059-.037,6.086.013a9.913,9.913,0,0,1,9.782,7.512,10.444,10.444,0,0,1-.842,7.55,9.629,9.629,0,0,1-6.906,5.09,13.522,13.522,0,0,1-2.481.244c-1.894.035-3.79.011-5.685.011a.754.754,0,0,1-.852-.807Q410.96,268.467,410.961,263.766Zm2.053,8.331h.31c1.32,0,2.64.017,3.959-.007a15.006,15.006,0,0,0,2.166-.158,7.111,7.111,0,0,0,6.038-4.977,10.4,10.4,0,0,0,.289-5.2,7.509,7.509,0,0,0-1.7-3.679,7.823,7.823,0,0,0-5.889-2.612c-1.667-.064-3.338-.017-5.008-.017a1.1,1.1,0,0,0-.162.023Z" transform="translate(-342.753 -253.502)" fill="#233043" />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="d-flex align-items-baseline">
                <p class="mr-5" style="font-size: 11px">Order Policy</p>
                <p class="mr-5" style="font-size: 11px">Delivery Policy</p>
                <p style="font-size: 11px">Sales Catalogue Policy</p>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-container>
    </template>
    <!-- STEP 2 -->
    <template v-else-if="step == 3">
      <b-container class="vh-100 d-flex flex-column">
        <div class="position-fixed" style="z-index: 1; top: 50px; left: 50px" v-bind:class="{ 'd-none': innerWidth <= BREAKPOINTS.LG }">
          <Logo :image="cache.settings[0].logo" :url="cache.settings[0].url" />
          <h4 class="text-uppercase mt-4 ls-08 no-weglot">
            {{ product.name }}
          </h4>
        </div>
        <b-row
          v-bind:style="{
            'margin-top': innerWidth > BREAKPOINTS.LG ? '200px' : '10px',
            'margin-bottom': innerWidth > BREAKPOINTS.LG ? '0' : '35px',
          }"
        >
          <transition appear name="fade">
            <b-col cols="12" lg="6">
              <Logo class="mb-3" v-if="innerWidth <= BREAKPOINTS.LG" />
              <h2
                class="font-weight-bold ls-08 mt-5"
                v-bind:style="{
                  'font-size': innerWidth > BREAKPOINTS.LG ? '32px' : '25px',
                }"
              >
                Thank you
              </h2>
              <p class="mt-4 ls-08"><b>We have received your request</b></p>
              <p class="text-muted mb-5">A contact person from the dealer will contact you soon. In the meantime, we recommend that you take a look at our sales catalogue.</p>
              <div style="display: flex; gap: 20px">
                <div class="button__interaction">
                  <router-link class="d-flex flex-column align-items-center justify-content-center" :to="'/'">
                    <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
                    <p class="m-0" style="margin-top: 9px !important; font-size: 13px; color: #666666">New build</p>
                  </router-link>
                </div>
                <div class="button__interaction">
                  <div class="d-flex flex-column align-items-center justify-content-center" style="cursor: pointer; position: relative" v-on:click="copyURL">
                    <div style="position: absolute; top: -65px; white-space: nowrap">
                      <b-alert style="background-color: #e5ebf5; color: black; border-color: #e5ebf5; font-size: 16px" :show="dismissCountDown" variant="warning" @dismissed="dismissCountDown = 0">URL copied to clipboard</b-alert>
                    </div>
                    <b-icon icon="share" aria-hidden="true"></b-icon>
                    <p class="m-0" style="margin-top: 9px !important; font-size: 13px; color: #666666">Share</p>
                  </div>
                </div>
                <div class="button__interaction">
                  <a class="d-flex flex-column align-items-center justify-content-center" style="cursor: pointer" target="_blank" href="https://firebasestorage.googleapis.com/v0/b/rand-boats.appspot.com/o/RAND%20Boats%20Catalogue%202023%20(Online).pdf?alt=media&token=070d95df-75e4-4278-978f-836034840413">
                    <b-icon icon="download" aria-hidden="true"></b-icon>
                    <p class="m-0" style="margin-top: 9px !important; font-size: 13px; color: #666666">Download</p>
                  </a>
                </div>
                <!-- <b-button variant="primary" class="mr-3 text-uppercase ls-08 fs-14" to="/" v-bind:class="{ 'w-100': innerWidth <= BREAKPOINTS.LG }">Back to start</b-button> -->
                <!-- <b-button
                  variant="secondary"
                  class="text-uppercase ls-08 fs-14"
                  v-bind:class="{
                    'w-100': innerWidth <= BREAKPOINTS.LG,
                    'mt-3': innerWidth <= BREAKPOINTS.LG,
                  }"
                  target="_blank"
                  href="https://firebasestorage.googleapis.com/v0/b/rand-boats.appspot.com/o/RAND%20Boats%20Catalogue%202023%20(Online).pdf?alt=media&token=070d95df-75e4-4278-978f-836034840413"
                  >Download brochure</b-button
                > -->
              </div>
            </b-col>
          </transition>
          <transition appear name="fade2">
            <b-col cols="6" class="d-flex flex-column justify-content-center" v-if="innerWidth >= BREAKPOINTS.LG">
              <div
                style="flex: 1"
                class=""
                v-bind:class="{
                  'overflow-hidden': innerWidth <= BREAKPOINTS.LG,
                }"
              >
                <div class="position-relative h-100 d-flex align-items-center justify-content-center">
                  <template v-for="(option, index) in configuration.options">
                    <img class="position-absolute w-100" v-if="option[view]" :src="option[view]" :alt="option.name" :key="index" />
                  </template>
                </div>
              </div>
            </b-col>
          </transition>
        </b-row>
      </b-container>
    </template>
  </b-container>
</template>

<script>
//TODO - selectClass not working on load

import Logo from '@/components/Logo.vue'
// import Preview2D from "@/components/Preview2D.vue";
import AnimatedNumber from 'animated-number-vue'
import cWeglot from '@/components/cWeglot.vue'

import firebase from 'firebase/compat/app'
import { firestore, storage } from '@/firebase'
import { getFunctions, httpsCallable } from 'firebase/functions'

import { mapState } from 'vuex'

import { BREAKPOINTS, numberToEuro } from '@/utility'

export default {
  name: 'Home',
  components: {
    Logo,
    AnimatedNumber,
    cWeglot,
    // Preview2D,
  },
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: 'Boat Configurator',
  },
  data() {
    return {
      loading: {
        message: 'Loading configurator..',
      },
      BREAKPOINTS,
      step: -1,
      showStandard: false,
      ready: false,
      product: {},
      configuration: {
        product: '',
        options: [],
      },
      innerHeight: '100px',
      tabs: {
        engine: 'electric',
      },
      images: [],
      options: [],
      quote: {
        country: null,
        cardinal: null,
      },
      view: 'front',
      // todo move into database when caching is introduced
      countries: [
        { value: null, text: 'Country' },
        { value: 'AF', text: 'Afghanistan' },
        { value: 'AF', text: 'Afghanistan' },
        { value: 'AL', text: 'Albania' },
        { value: 'DZ', text: 'Algeria' },
        { value: 'AS', text: 'American Samoa' },
        { value: 'AD', text: 'Andorra' },
        { value: 'AO', text: 'Angola' },
        { value: 'AI', text: 'Anguilla' },
        { value: 'AQ', text: 'Antarctica' },
        { value: 'AG', text: 'Antigua and Barbuda' },
        { value: 'AR', text: 'Argentina' },
        { value: 'AM', text: 'Armenia' },
        { value: 'AW', text: 'Aruba' },
        { value: 'AU', text: 'Australia' },
        { value: 'AT', text: 'Austria' },
        { value: 'AZ', text: 'Azerbaijan' },
        { value: 'BS', text: 'Bahamas' },
        { value: 'BH', text: 'Bahrain' },
        { value: 'BD', text: 'Bangladesh' },
        { value: 'BB', text: 'Barbados' },
        { value: 'BY', text: 'Belarus' },
        { value: 'BE', text: 'Belgium' },
        { value: 'BZ', text: 'Belize' },
        { value: 'BJ', text: 'Benin' },
        { value: 'BM', text: 'Bermuda' },
        { value: 'BT', text: 'Bhutan' },
        { value: 'BO', text: 'Bolivia (Plurinational State of)' },
        { value: 'BQ', text: 'Bonaire, Sint Eustatius and Saba' },
        { value: 'BA', text: 'Bosnia and Herzegovina' },
        { value: 'BW', text: 'Botswana' },
        { value: 'BV', text: 'Bouvet Island' },
        { value: 'BR', text: 'Brazil' },
        { value: 'IO', text: 'British Indian Ocean Territory' },
        { value: 'BN', text: 'Brunei Darussalam' },
        { value: 'BG', text: 'Bulgaria' },
        { value: 'BF', text: 'Burkina Faso' },
        { value: 'BI', text: 'Burundi' },
        { value: 'CV', text: 'Cabo Verde' },
        { value: 'KH', text: 'Cambodia' },
        { value: 'CM', text: 'Cameroon' },
        { value: 'CA', text: 'Canada' },
        { value: 'KY', text: 'Cayman Islands' },
        { value: 'CF', text: 'Central African Republic' },
        { value: 'TD', text: 'Chad' },
        { value: 'CL', text: 'Chile' },
        { value: 'CN', text: 'China' },
        { value: 'CX', text: 'Christmas Island' },
        { value: 'CC', text: 'Cocos (Keeling) Islands' },
        { value: 'CO', text: 'Colombia' },
        { value: 'KM', text: 'Comoros' },
        { value: 'CD', text: 'Congo (the Democratic Republic of the)' },
        { value: 'CG', text: 'Congo' },
        { value: 'CK', text: 'Cook Islands' },
        { value: 'CR', text: 'Costa Rica' },
        { value: 'HR', text: 'Croatia' },
        { value: 'CU', text: 'Cuba' },
        { value: 'CW', text: 'Curaçao' },
        { value: 'CY', text: 'Cyprus' },
        { value: 'CZ', text: 'Czechia' },
        { value: 'CI', text: "Côte d'Ivoire" },
        { value: 'DK', text: 'Denmark' },
        { value: 'DJ', text: 'Djibouti' },
        { value: 'DM', text: 'Dominica' },
        { value: 'DO', text: 'Dominican Republic' },
        { value: 'EC', text: 'Ecuador' },
        { value: 'EG', text: 'Egypt' },
        { value: 'SV', text: 'El Salvador' },
        { value: 'GQ', text: 'Equatorial Guinea' },
        { value: 'ER', text: 'Eritrea' },
        { value: 'EE', text: 'Estonia' },
        { value: 'SZ', text: 'Eswatini' },
        { value: 'ET', text: 'Ethiopia' },
        { value: 'FK', text: 'Falkland Islands [Malvinas]' },
        { value: 'FO', text: 'Faroe Islands' },
        { value: 'FJ', text: 'Fiji' },
        { value: 'FI', text: 'Finland' },
        { value: 'FR', text: 'France' },
        { value: 'GF', text: 'French Guiana' },
        { value: 'PF', text: 'French Polynesia' },
        { value: 'TF', text: 'French Southern Territories' },
        { value: 'GA', text: 'Gabon' },
        { value: 'GM', text: 'Gambia' },
        { value: 'GE', text: 'Georgia' },
        { value: 'DE', text: 'Germany' },
        { value: 'GH', text: 'Ghana' },
        { value: 'GI', text: 'Gibraltar' },
        { value: 'GR', text: 'Greece' },
        { value: 'GL', text: 'Greenland' },
        { value: 'GD', text: 'Grenada' },
        { value: 'GP', text: 'Guadeloupe' },
        { value: 'GU', text: 'Guam' },
        { value: 'GT', text: 'Guatemala' },
        { value: 'GG', text: 'Guernsey' },
        { value: 'GN', text: 'Guinea' },
        { value: 'GW', text: 'Guinea-Bissau' },
        { value: 'GY', text: 'Guyana' },
        { value: 'HT', text: 'Haiti' },
        { value: 'HM', text: 'Heard Island and McDonald Islands' },
        { value: 'VA', text: 'Holy See' },
        { value: 'HN', text: 'Honduras' },
        { value: 'HK', text: 'Hong Kong' },
        { value: 'HU', text: 'Hungary' },
        { value: 'IS', text: 'Iceland' },
        { value: 'IN', text: 'India' },
        { value: 'ID', text: 'Indonesia' },
        { value: 'IR', text: 'Iran (Islamic Republic of)' },
        { value: 'IQ', text: 'Iraq' },
        { value: 'IE', text: 'Ireland' },
        { value: 'IM', text: 'Isle of Man' },
        { value: 'IL', text: 'Israel' },
        { value: 'IT', text: 'Italy' },
        { value: 'JM', text: 'Jamaica' },
        { value: 'JP', text: 'Japan' },
        { value: 'JE', text: 'Jersey' },
        { value: 'JO', text: 'Jordan' },
        { value: 'KZ', text: 'Kazakhstan' },
        { value: 'KE', text: 'Kenya' },
        { value: 'KI', text: 'Kiribati' },
        { value: 'KP', text: "Korea (the Democratic People's Republic of)" },
        { value: 'KR', text: 'Korea (the Republic of)' },
        { value: 'KW', text: 'Kuwait' },
        { value: 'KG', text: 'Kyrgyzstan' },
        { value: 'LA', text: "Lao People's Democratic Republic" },
        { value: 'LV', text: 'Latvia' },
        { value: 'LB', text: 'Lebanon' },
        { value: 'LS', text: 'Lesotho' },
        { value: 'LR', text: 'Liberia' },
        { value: 'LY', text: 'Libya' },
        { value: 'LI', text: 'Liechtenstein' },
        { value: 'LT', text: 'Lithuania' },
        { value: 'LU', text: 'Luxembourg' },
        { value: 'MO', text: 'Macao' },
        { value: 'MG', text: 'Madagascar' },
        { value: 'MW', text: 'Malawi' },
        { value: 'MY', text: 'Malaysia' },
        { value: 'MV', text: 'Maldives' },
        { value: 'ML', text: 'Mali' },
        { value: 'MT', text: 'Malta' },
        { value: 'MH', text: 'Marshall Islands' },
        { value: 'MQ', text: 'Martinique' },
        { value: 'MR', text: 'Mauritania' },
        { value: 'MU', text: 'Mauritius' },
        { value: 'YT', text: 'Mayotte' },
        { value: 'MX', text: 'Mexico' },
        { value: 'FM', text: 'Micronesia (Federated States of)' },
        { value: 'MD', text: 'Moldova (the Republic of)' },
        { value: 'MC', text: 'Monaco' },
        { value: 'MN', text: 'Mongolia' },
        { value: 'ME', text: 'Montenegro' },
        { value: 'MS', text: 'Montserrat' },
        { value: 'MA', text: 'Morocco' },
        { value: 'MZ', text: 'Mozambique' },
        { value: 'MM', text: 'Myanmar' },
        { value: 'NA', text: 'Namibia' },
        { value: 'NR', text: 'Nauru' },
        { value: 'NP', text: 'Nepal' },
        { value: 'NL', text: 'Netherlands' },
        { value: 'NC', text: 'New Caledonia' },
        { value: 'NZ', text: 'New Zealand' },
        { value: 'NI', text: 'Nicaragua' },
        { value: 'NE', text: 'Niger' },
        { value: 'NG', text: 'Nigeria' },
        { value: 'NU', text: 'Niue' },
        { value: 'NF', text: 'Norfolk Island' },
        { value: 'MP', text: 'Northern Mariana Islands' },
        { value: 'NO', text: 'Norway' },
        { value: 'OM', text: 'Oman' },
        { value: 'PK', text: 'Pakistan' },
        { value: 'PW', text: 'Palau' },
        { value: 'PS', text: 'Palestine, State of' },
        { value: 'PA', text: 'Panama' },
        { value: 'PG', text: 'Papua New Guinea' },
        { value: 'PY', text: 'Paraguay' },
        { value: 'PE', text: 'Peru' },
        { value: 'PH', text: 'Philippines' },
        { value: 'PN', text: 'Pitcairn' },
        { value: 'PL', text: 'Poland' },
        { value: 'PT', text: 'Portugal' },
        { value: 'PR', text: 'Puerto Rico' },
        { value: 'QA', text: 'Qatar' },
        { value: 'MK', text: 'Republic of North Macedonia' },
        { value: 'RO', text: 'Romania' },
        { value: 'RU', text: 'Russian Federation' },
        { value: 'RW', text: 'Rwanda' },
        { value: 'RE', text: 'Réunion' },
        { value: 'BL', text: 'Saint Barthélemy' },
        { value: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha' },
        { value: 'KN', text: 'Saint Kitts and Nevis' },
        { value: 'LC', text: 'Saint Lucia' },
        { value: 'MF', text: 'Saint Martin (French part)' },
        { value: 'PM', text: 'Saint Pierre and Miquelon' },
        { value: 'VC', text: 'Saint Vincent and the Grenadines' },
        { value: 'WS', text: 'Samoa' },
        { value: 'SM', text: 'San Marino' },
        { value: 'ST', text: 'Sao Tome and Principe' },
        { value: 'SA', text: 'Saudi Arabia' },
        { value: 'SN', text: 'Senegal' },
        { value: 'RS', text: 'Serbia' },
        { value: 'SC', text: 'Seychelles' },
        { value: 'SL', text: 'Sierra Leone' },
        { value: 'SG', text: 'Singapore' },
        { value: 'SX', text: 'Sint Maarten (Dutch part)' },
        { value: 'SK', text: 'Slovakia' },
        { value: 'SI', text: 'Slovenia' },
        { value: 'SB', text: 'Solomon Islands' },
        { value: 'SO', text: 'Somalia' },
        { value: 'ZA', text: 'South Africa' },
        { value: 'GS', text: 'South Georgia and the South Sandwich Islands' },
        { value: 'SS', text: 'South Sudan' },
        { value: 'ES', text: 'Spain' },
        { value: 'LK', text: 'Sri Lanka' },
        { value: 'SD', text: 'Sudan' },
        { value: 'SR', text: 'Suriname' },
        { value: 'SJ', text: 'Svalbard and Jan Mayen' },
        { value: 'SE', text: 'Sweden' },
        { value: 'CH', text: 'Switzerland' },
        { value: 'SY', text: 'Syrian Arab Republic' },
        { value: 'TW', text: 'Taiwan' },
        { value: 'TJ', text: 'Tajikistan' },
        { value: 'TZ', text: 'Tanzania, United Republic of' },
        { value: 'TH', text: 'Thailand' },
        { value: 'TL', text: 'Timor-Leste' },
        { value: 'TG', text: 'Togo' },
        { value: 'TK', text: 'Tokelau' },
        { value: 'TO', text: 'Tonga' },
        { value: 'TT', text: 'Trinidad and Tobago' },
        { value: 'TN', text: 'Tunisia' },
        { value: 'TR', text: 'Turkey' },
        { value: 'TM', text: 'Turkmenistan' },
        { value: 'TC', text: 'Turks and Caicos Islands' },
        { value: 'TV', text: 'Tuvalu' },
        { value: 'UG', text: 'Uganda' },
        { value: 'UA', text: 'Ukraine' },
        { value: 'AE', text: 'United Arab Emirates' },
        {
          value: 'GB',
          text: 'United Kingdom',
        },
        { value: 'UM', text: 'United States Minor Outlying Islands' },
        { value: 'US', text: 'United States of America' },
        { value: 'UY', text: 'Uruguay' },
        { value: 'UZ', text: 'Uzbekistan' },
        { value: 'VU', text: 'Vanuatu' },
        { value: 'VE', text: 'Venezuela (Bolivarian Republic of)' },
        { value: 'VN', text: 'Viet Nam' },
        { value: 'VG', text: 'Virgin Islands (British)' },
        { value: 'VI', text: 'Virgin Islands (U.S.)' },
        { value: 'WF', text: 'Wallis and Futuna' },
        { value: 'EH', text: 'Western Sahara' },
        { value: 'YE', text: 'Yemen' },
        { value: 'ZM', text: 'Zambia' },
        { value: 'ZW', text: 'Zimbabwe' },
        { value: 'AX', text: 'Åland Islands' },
      ],
      cardinals: [
        { value: null, text: 'Region' },
        { value: 'N', text: 'North' },
        { value: 'S', text: 'South' },
        { value: 'E', text: 'East' },
        { value: 'W', text: 'West' },
      ],
      standardConfig: {},
      lastSelected: {},
      cache: {},
      sending: false,
      firstLoad: true,
      dismissCountDown: 0,
      intlTelInput: null,
    }
  },
  computed: {
    ...mapState(['innerWidth']),
  },
  watch: {
    $route(to) {
      if (this.firstLoad) {
        if (to.params.product) {
          this.setup()
        } else {
          this.step = 0
        }
        this.firstLoad = false
      }
    },
    //this.intlTelInput.getNumber()
    step() {
      this.$nextTick(() => {
        const input = this.$refs['intlTelInput']
        if (input && this.intlTelInput == null) {
          this.intlTelInput = window.intlTelInput(input, {
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
            fixDropdownWidth: true,
            initialCountry: 'DK',
            showSelectedDialCode: true,
          })
        }
      })
    },
  },
  // computed: {
  //   test(){
  //     return this.configuration.options.reverse();
  //   }
  // },
  mounted() {
    this.innerHeight = window.innerHeight + 'px'
    this.firstLoad = false
  },
  created() {
    firebase.firestore().settings({
      experimentalForceLongPolling: true,
      merge: true,
    })
    console.log('experimentalForceLongPolling')
    this.$bind('cache', firestore.collection('_cache').doc('CoGEnpNIVuexy5SNhojT2'), { maxRefDepth: 0 }).then(() => {
      this.cache.products.sort((a, b) => {
        return a.name.split(' ')[1] - b.name.split(' ')[1]
      })
      if (this.cache.settings[0].head) {
        document.head.innerHTML = document.head.innerHTML + this.cache.settings[0].head
      }
      if (this.$route.params.product) {
        this.setup()
      } else {
        this.step = 0
      }
    })
  },
  methods: {
    getPhoneNumber() {
      let dialCode = '+' + this.intlTelInput.getSelectedCountryData().dialCode
      let entireNumber = this.intlTelInput.getNumber()
      let justNumber

      if (entireNumber.startsWith(dialCode)) {
        justNumber = entireNumber.substring(dialCode.length)
      }
      return `(${dialCode}), ${justNumber}`
    },
    copyURL() {
      const currentUrl = window.location.href
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          console.log('URL copied to clipboard successfully!')
          this.dismissCountDown = 2
        })
        .catch((err) => {
          console.error('Failed to copy URL: ', err)
        })
    },
    updateURL() {
      var optionUids = this.configuration.options.map((option) => option._reference)
      const concatenated = optionUids.join(';')
      const encoded = btoa(concatenated)
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          options: encoded,
        },
      })
    },
    formatRange(value) {
      return `<p class="preview2d__unit">${Number(value).toFixed(0)} km</p>`
    },
    formatTopSpeed(value) {
      return `<p class="preview2d__unit">${Number(value).toFixed(0)} knots</p>`
    },
    formatAcceleration(value) {
      return `<p class="preview2d__unit">${Number(value).toFixed(1)}s</p>`
    },
    numberToEuro,
    setup() {
      this.product = this.cache.products.find((e) => {
        return e.url == this.$route.params.product ? true : false
      })
      this.loading.message = `Loading ${this.product.name}..`
      this.step = -1
      this.options = this.cache.options.filter((option) => {
        if (option.product == this.product._reference) {
          return option
        }
      })
      this.options = this.options.sort((a, b) => {
        return a.price - b.price
      })
      let promises = []
      this.options.forEach((option) => {
        let arr = ['thumbnail', 'front', 'rear']
        arr.forEach((key) => {
          if (option[key]) {
            promises.push(
              storage
                .download(option[key])
                .then((resolve) => {
                  this.$set(option, [key], resolve)
                })
                .catch((err) => {
                  console.log(err)
                })
            )
          } else {
            if (key == 'thumbnail') {
              this.$set(option, [key], 'https://firebasestorage.googleapis.com/v0/b/rand-boats.appspot.com/o/rand-thumb-random.jpg?alt=media&token=c6c2f636-0822-420f-9f10-bbba162441b3')
            }
          }
        })
      })
      // this.metaInfo.title = "Test Test";
      Promise.all(promises).then(() => {
        this.configuration.product = this.product
        if (this.$route.query.configuration) {
          console.log('had a config')
          this.$bind('standardConfig', firestore.collection('configurations').doc(this.$route.query.configuration)).then(() => {
            this.standardConfig.options = this.standardConfig.options.map((option) => {
              return this.options.find((el) => {
                return el._reference == 'options/' + option.id
              })
            })
            this.configuration = this.standardConfig
            this.step = 3
            this.ready = true
          })
        } else {
          this.configuration.options = this.options.filter((option) => {
            if (option.category == 'categories/aalPMGzfcStxi1NYiDkh') {
              this.configuration.range = option.range || 602
              this.configuration.acceleration = option.acceleration || 4.4
              this.configuration.top_speed = option.top_speed || 233
            }
            return option.standard
          })
          this.standardConfig = this.configuration
          this.step = 1
          this.ready = true
        }
        this.configuration.options.forEach((element) => {
          this.lastSelected[element.category] = this.lastSelected[element.category] || element
        })
        if (!this.$route.query.options) {
          this.updateURL()
        } else {
          if (this.$route.query.options) {
            var decoded = atob(decodeURIComponent(this.$route.query.options))
            decoded = decoded.split(';')
            let options = decoded.map((str) => {
              return this.cache.options.find((obj) => obj._reference === str)
            })
            options.forEach((option) => {
              this.toggleOption(option.category, option)
            })
          }
        }
      })
    },
    getObjectByReferenceEquals(array, key, value) {
      return array.find((element) => {
        return element[key] == value ? true : false
      })
    },
    reset() {
      this.configuration.options = this.options.filter((option) => {
        return option.standard
      })
    },
    getOptions: function (category) {
      let arr = this.options.filter((option) => {
        if (category == option.category) {
          return option
        }
      })
      return arr
    },
    //will the prices be in decimal form?
    getPrice() {
      let price = parseInt(this.product.price)
      this.configuration.options.forEach((option) => {
        price += parseInt(option.price)
      })
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    switchSide() {
      if (this.view == 'front') {
        this.view = 'rear'
      } else {
        this.view = 'front'
      }
    },
    onSubmit() {
      this.sending = true
      let config = { ...this.configuration }
      // config.product = firestore.doc(`${this.product.reference}`)
      // config.options = config.options.map((option) => {
      //   return firestore.doc(`${option.reference}`)
      // })
      config.product = this.product._reference
      config.options = config.options.map((option) => {
        return option._reference
      })
      config.price = this.getPrice()
      config.acceleration = config.acceleration || ''
      config.range = config.range || ''
      config.top_speed = config.top_speed || ''
      const callable = httpsCallable(getFunctions(), 'submitRequest')
      this.quote.phone = this.getPhoneNumber()
      callable({
        configuration: JSON.parse(JSON.stringify(config)),
        request: JSON.parse(JSON.stringify(this.quote)),
      })
        .then(() => {
          this.step = 3
          this.sending = false
        })
        .catch((reason) => {
          alert('Something went wrong. Please refresh your browser and try again!')
          console.error('submitting failed', reason)
          this.sending = false
        })
      // firestore
      //   .collection('configurations')
      //   .add(config)
      //   .then((docRef) => {
      //     this.quote.configuration = docRef
      //     return firestore.collection('requests').add(this.quote)
      //   })
      //   .then(() => {
      //     this.step = 3
      //   })
    },
    selectedClass(option) {
      return this.configuration.options.indexOf(option) != -1
    },
    toggleOption(category, option) {
      if (category == 'categories/aalPMGzfcStxi1NYiDkh') {
        this.configuration.range = option.range
        this.configuration.acceleration = option.acceleration
        this.configuration.top_speed = option.top_speed
      }
      const optionIndex = this.configuration.options.indexOf(option)
      const allTheOptionsOfThisCategory = this.configuration.options.filter((option) => {
        return option.category == category
      })
      if (optionIndex != -1) {
        if (allTheOptionsOfThisCategory) {
          if (!this.getObjectByReferenceEquals(this.cache.categories, '_reference', category).required || allTheOptionsOfThisCategory.length > 1) {
            this.configuration.options.splice(optionIndex, 1)
            this.lastSelected[category] = undefined
          } else {
            return
          }
        }
      } else {
        if (this.getObjectByReferenceEquals(this.cache.categories, '_reference', category).multiple) {
          this.configuration.options.push(option)
        } else {
          this.configuration.options = this.configuration.options.filter((element) => {
            return element.category != category
          })
          this.configuration.options.push(option)
        }
        this.lastSelected[category] = option
      }
      this.updateURL()
    },
  },
}
</script>

<style lang="scss">
// CUSTOM BOOTSTRAP
.ls-08 {
  letter-spacing: 0.8px;
}
.fs-10 {
  font-size: 10px;
}
.fs-14 {
  font-size: 14px;
}
.only-on-mobile {
  display: none;
}
.selected {
  border: solid 2px #253043 !important;
}
.selected2 {
  border-radius: 7px;
  border: solid 2px #253043 !important;
}
.custom-scrollbar::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: lightgray;

  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgb(100, 100, 100);
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: black;
}
@media (max-width: 992px) {
  .hide-on-mobile {
    display: none;
  }
  .only-on-mobile {
    display: block;
  }
  .no-margin-mobile {
    margin-bottom: 20px !important;
  }
}
@media (min-width: 993px) {
  .margin-on-desktop {
    margin-top: 50px !important;
  }
}

@media (max-width: 1100px) {
  .product {
    &__image {
      width: 100%;
    }
    &__card {
      min-height: 310px;
    }
    &__title {
      margin-top: 15px;
    }
    &__col {
      position: fixed;
      left: 0;
      background-color: white;
      margin-top: -1.5rem;
      z-index: 2;
      border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }
    &__order {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    &__options {
      margin-top: 300px;
      padding-bottom: 75px !important;
    }
  }
  .margin--hack {
    margin-right: 15px;
  }
}
@media (min-width: 1100px) {
  .product {
    &__col,
    &__card {
      height: 100%;
    }
    &__options {
      height: 100%;
    }
  }
}
.cursor-pointer {
  cursor: pointer;
}
.no-appearance {
  -webkit-appearance: none;
}
// .fade-enter-from{
//   opacity: 0;
// }
// .fade-enter-to{
//   opacity: 1;
// }
// .fade-enter-active {
//   transition: all 4s ease;
// }
// .fade-leave-from{
//   opacity: 1;
// }
// .fade-leave-to{
//   opacity: 0;
// }
// .fade-leave-active{
//   transition: all 4s ease;
// }
// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 5.5s ease;
// }

// .fade-enter-from,
// .fade-leave-to {
//   opacity: 0;
// }

// .fade {
//   animation: fade 1s ease;
//   opacity: 1;
// }
// @keyframes fade {
//   0% {opacity:0;}
//   100% {opacity:1;}
// }

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 0.8s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.hover-zoom {
  transition: all 0.1s ease;
}

.hover-zoom2 {
  transition: all 0.1s ease;
}
.hover-zoom2:hover {
  transform: scale(0.98);
}

.hover-zoom:hover {
  transform: scale(0.9);
}
.button-primary {
  background: white;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.title-font {
  font-size: 14px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

.preview2d__unit {
  text-align: center;
  font-weight: 300;
  font-size: 28px;
  @media only screen and (max-width: 992px) {
    margin: 0;
    font-size: 16px;
  }
}

.preview2d__description {
  text-align: center;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 0.1em;
  font-size: 13px;
  @media only screen and (max-width: 992px) {
    font-size: 11px;
    margin: 0;
  }
}

.notification {
  background-color: #253043;
  color: white;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 20px;
  a {
    color: white;
    text-decoration: underline;
  }
  p {
    margin: 0;
  }
}

.button__interaction {
  width: 100px;
  display: flex;
  justify-content: center;
  height: 100px;
  background-color: rgb(229, 235, 245);
  border-radius: 5px;
}

.iti {
  width: 100%;
}

.request {
  &__nav {
    display: flex;
    gap: 31.5px;
    p {
      font-size: 12px;
      line-height: 15px;
      opacity: 0.5;
      cursor: pointer;
    }
    .current {
      cursor: initial;
      opacity: 1;
      padding-bottom: 13.5px;
      border-bottom: 2px solid #000000;
    }
  }
  &__flex {
    margin-top: 200px;
  }
}

// if device is less then ipad mini
@media only screen and (max-width: 1200px) {
  .notification-title {
    display: none !important;
  }
  .main-body {
    padding: 2rem !important;
  }
  .router-links {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .router-button {
    width: 150px !important;
  }
}

@media only screen and (min-width: 991px) and (max-width: 1200px) {
  .switchers {
    flex-direction: column-reverse !important;
    align-items: flex-start !important;
  }
  .option-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    h5 {
      margin-bottom: 0.5rem !important;
    }
    p {
      margin-bottom: 1rem !important;
    }
  }
  .option-body {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    flex-wrap: wrap !important;
  }
}

@media only screen and (max-width: 575px) {
  .option-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    h5 {
      margin-bottom: 0.5rem !important;
    }
    p {
      margin-bottom: 1rem !important;
    }
  }
  .option-body {
    display: flex !important;
    flex-direction: row !important;
    align-content: flex-start !important;
    flex-wrap: wrap !important;
  }
}

@media only screen and (max-width: 992px) {
  .request {
    &__flex {
      margin-top: 60px;
    }
  }
}
</style>
